import { AuthInformation } from "../../domain/models/auth_information";
import { ConfigureLogin } from "../../domain/models/configure_login";
import { Enterprise } from "../../domain/models/enterprise";
import { IAuthRepository } from "../../domain/repositories/auth_repository";
import { IAuthService } from "../services/auth_service";

/**
 * AuthRepository
 */

export class AuthRepository implements IAuthRepository {
  constructor(
    private readonly authService: IAuthService,
  ) { }

  async esqueceuSuaSenha(email: string): Promise<void> {
    await this.authService.esqueceuSuaSenha({ email });
  }

  async login(email: string, password: string): Promise<AuthInformation> {
    const response = await this.authService.login({ login: email, password });
    return { ...response };
  }

  async getEnterprises(): Promise<Enterprise[]> {
    const response = await this.authService.getEnterprises();
    return [...response.enterprises];
  }

  async configureLogin(loginAntigo: string, oldPassword: string, loginNovo: string, newPassword: string, empresaId: number, newLogin: string | undefined): Promise<ConfigureLogin> {
    const response = await this.authService.configureLogin({ loginAntigo, oldPassword, loginNovo, newPassword, empresaId, newLogin });
    return { ...response };
  }

  async loginAvailable(login: string, empresaId: number): Promise<boolean> {
    const response = await this.authService.loginAvailable({ login, empresaId, WithLoginInterno: true });
    return response;
  }

  async trocarSenha(login: string, senhaAtual: string, novaSenha: string): Promise<void> {
    await this.authService.trocarSenha({ login, senhaAtual, novaSenha });
  }
}